import { render } from "./FireIcon.vue?vue&type=template&id=cb391c88"
import script from "./FireIcon.vue?vue&type=script&lang=js"
export * from "./FireIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__